import { BaseApi } from "../utils/request";

export interface BatchBonusClaimResp {
  /** OK / ALREADY_CLAIMED / EXPIRED / NOT_FOUND / FAILED */
  status: string;
  endTime?: string | number | null;
  amount?: number | null;
  /** 批量赠金通知类型配置的图标（原始 resourceId），前端 store 无图标时兜底 */
  icon?: string | null;
}

/** 批量赠金状态更新事件：领取成功后派发，通知邮件图标/列表刷新 */
export const BATCH_BONUS_UPDATED_EVENT = "batch-bonus-updated";

/** 站内信 BATCHBONUS_ACTIVITY 按钮跳转的领取路径（Gate/按钮状态/路由共用，避免各处硬编码漂移） */
export const BATCH_BONUS_CLAIM_PATH = "/activity/batch-bonus-claim";

/**
 * 批量赠金（F31）用户前台领取接口。
 * 站内信 BATCHBONUS_ACTIVITY 按钮通过 messagePath /activity/batch-bonus-claim?id=<recordId>
 * 打开弹窗后调用本接口触发领取。
 */
export class BatchBonusApi extends BaseApi {
  async claim(id: string) {
    return this.post<BatchBonusClaimResp, true>("/api/batch_bonus/claim", { id });
  }

  /** 查询领取状态（无副作用），用于站内信/详情页按钮状态渲染。 */
  async status(id: string) {
    return this.post<BatchBonusClaimResp, true>("/api/batch_bonus/status", { id });
  }
}

export const batchBonusApi = new BatchBonusApi();
